import { BaseApiClient } from '../../../lib/api/BaseApiClient';
import { ENV } from '../../../config/env';

// Maps to the "Updates" folder. Web build info sent as best-effort.
class UpdatesApi extends BaseApiClient {
  constructor() { super('Updates', { public: true }); }

  // POST /Updates/CheckVersion  body: { app, versionNo, osType }
  checkVersion() {
    return this.raw('post', '/CheckVersion', {
      app: 'customer',
      versionNo: ENV.APP_VERSION || '0.1.0',
      osType: 'web',
    });
  }
}

export const updatesApi = new UpdatesApi();
